import React from 'react';
import { ChevronRightIcon } from '../../Icons';
import styles from '../index.module.scss';

export const BreadcrumbSeparator: React.FC = () => {
  return (
    <span className={styles.separator} aria-hidden={true}>
      <ChevronRightIcon size='xs' />
    </span>
  );
};
